import { useEffect, useState } from "react";

const DEFAULT_BRANDING = Object.freeze({
  APP_TITLE: "Proctored Assessment",
  ORG_NAME: "Demo University",
  FACULTY_NAME: "Demo Faculty",
  CAMPUS_ADDRESS: "Demo Campus Address",
  LOGO_ALT_TEXT: "Organization Logo",
  ACADEMIC_YEAR_FALLBACK: "2024-25",
  BRAND_PRIMARY_LOGO: "/branding/logo.png",
  BRAND_SECONDARY_LOGO: "",
  LOGIN_LOGO: "/branding/logo.png",
  PDF_LOGO: "/branding/logo.png",
  LOGIN_WALLPAPER: "/branding/campus-wallpaper.jpg",
  MEDIA_BASE_URL: process.env.REACT_APP_MEDIA_BASE_URL || "",
});

let brandingCache = null;
let brandingPromise = null;

const getBrandingFileUrl = () => {
  const publicUrl = process.env.PUBLIC_URL || "";
  return `${publicUrl}/branding/branding.txt`;
};

const parseBrandingText = (text) => {
  const values = {};

  text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .forEach((line) => {
      if (!line || line.startsWith("#")) return;

      const separatorIndex = line.indexOf("=");
      if (separatorIndex === -1) return;

      const key = line.slice(0, separatorIndex).trim();
      const value = line.slice(separatorIndex + 1).trim();
      if (key) {
        values[key] = value;
      }
    });

  return values;
};

export const loadBranding = async () => {
  if (brandingCache) return brandingCache;
  if (brandingPromise) return brandingPromise;

  brandingPromise = fetch(getBrandingFileUrl())
    .then((response) => {
      if (!response.ok) {
        throw new Error("branding.txt not found");
      }
      return response.text();
    })
    .then((text) => {
      brandingCache = {
        ...DEFAULT_BRANDING,
        ...parseBrandingText(text),
        MEDIA_BASE_URL: process.env.REACT_APP_MEDIA_BASE_URL || "",
      };
      return brandingCache;
    })
    .catch(() => {
      brandingCache = { ...DEFAULT_BRANDING };
      return brandingCache;
    });

  return brandingPromise;
};

export const useBranding = () => {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);

  useEffect(() => {
    let isMounted = true;

    loadBranding().then((data) => {
      if (isMounted) {
        setBranding(data);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return branding;
};

export const buildMediaUrl = (path, mediaBaseUrl = "") => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;

  if (mediaBaseUrl) {
    const normalizedBase = mediaBaseUrl.replace(/\/$/, "");
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${normalizedBase}${normalizedPath}`;
  }

  return path;
};

export const getDefaultBranding = () => DEFAULT_BRANDING;
